import Tooltip from "rc-tooltip";
import { Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { FaInfo, FaTimes } from "react-icons/fa";

const ViewPopOver = ({
  viewTarget,
  setViewTarget,
  setIsViewShow,
  isViewShow,
  parent,
  item,
}) => (
  <OverlayTrigger
    trigger="click"
    placement="right"
    show={isViewShow}
    overlay={
      <Popover id="popover-basic" style={{ width: 300, zIndex: 500 }}>
        <Popover.Header as="h3">
          <div className="d-flex justify-content-between">
            <div>View Menu</div>
            <FaTimes onClick={() => setIsViewShow(false)} />
          </div>
        </Popover.Header>
        <Popover.Body>
          <Row>
            <Col xs={4}>Menu</Col>
            <Col>{item.name}</Col>
          </Row>
          <Row>
            <Col xs={4}>Description</Col>
            <Col>{item.description}</Col>
          </Row>
          <Row>
            <Col xs={4}>Icon</Col>
            <Col>{item.icon}</Col>
          </Row>
          {parent ? (
            item.childMenus &&
            item.childMenus.length == 0 && (
              <Row>
                <Col xs={4}>Path</Col>
                <Col>{item.path}</Col>
              </Row>
            )
          ) : (
            <Row>
              <Col xs={4}>Path</Col>
              <Col>{item.path}</Col>
            </Row>
          )}
        </Popover.Body>
      </Popover>
    }
  >
    <Tooltip placement="top" overlay={<span>View Menu</span>}>
      <button
        className="btn btn-link btn-sm"
        type="button"
        onClick={(e) => {
          setViewTarget(e.target);
          setIsViewShow(true);
        }}
      >
        <FaInfo />
      </button>
    </Tooltip>
  </OverlayTrigger>
);
export default ViewPopOver;
